<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="15.415" height="12.261" viewBox="0 0 15.415 12.261">
		<g id="Group_29996" data-name="Group 29996" transform="translate(-1529.71 -249.87)">
			<g id="Group_29970" data-name="Group 29970">
				<g id="Group_29968" data-name="Group 29968" transform="translate(1533.311 250.471)">
					<g id="Group_29967" data-name="Group 29967" transform="translate(0 -0.001)">
						<line
							id="Line_871"
							data-name="Line 871"
							x2="11.215"
							fill="none"
							stroke="#5a677d"
							stroke-linecap="round"
							stroke-linejoin="round"
							stroke-width="1.2"
						/>
						<line
							id="Line_872"
							data-name="Line 872"
							x2="11.215"
							transform="translate(0 5.53)"
							fill="none"
							stroke="#5a677d"
							stroke-linecap="round"
							stroke-linejoin="round"
							stroke-width="1.2"
						/>
						<line
							id="Line_873"
							data-name="Line 873"
							x2="11.215"
							transform="translate(0 11.061)"
							fill="none"
							stroke="#5a677d"
							stroke-linecap="round"
							stroke-linejoin="round"
							stroke-width="1.2"
						/>
					</g>
				</g>
				<g id="Group_29969" data-name="Group 29969" transform="translate(1530.311 250.471)">
					<g id="Group_29967-2" data-name="Group 29967" transform="translate(0 -0.001)">
						<line
							id="Line_871-2"
							data-name="Line 871"
							x2="0.053"
							fill="none"
							stroke="#5a677d"
							stroke-linecap="round"
							stroke-linejoin="round"
							stroke-width="1.2"
						/>
						<line
							id="Line_872-2"
							data-name="Line 872"
							x2="0.053"
							transform="translate(0 5.53)"
							fill="none"
							stroke="#5a677d"
							stroke-linecap="round"
							stroke-linejoin="round"
							stroke-width="1.2"
						/>
						<line
							id="Line_873-2"
							data-name="Line 873"
							x2="0.053"
							transform="translate(0 11.061)"
							fill="none"
							stroke="#5a677d"
							stroke-linecap="round"
							stroke-linejoin="round"
							stroke-width="1.2"
						/>
					</g>
				</g>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'BulletListSvg',
};
</script>

<style scoped lang="scss"></style>
